export const ActionTypes = {
  LOADING: "GET_AREAS_PROGRESS_LOADING",
  ERROR: "GET_AREAS_PROGRESS_ERROR",
  SUCCESS: "GET_AREAS_PROGRESS_SUCCESS"
};
